/**
 * Lista de URLs Edge/Broker em um único campo (linha ou vírgula).
 * A primeira URL é a principal; as demais são failover.
 */

export function parseUrlTokens(raw?: string | null): string[] {
  if (!raw) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of String(raw).split(/[,;\n\r]+/)) {
    const t = part.trim().replace(/\/$/, '');
    if (t && !seen.has(t)) {
      seen.add(t);
      out.push(t);
    }
  }
  return out;
}

/** Junta principal + reservas para exibir num textarea (uma URL por linha). */
export function joinUrlList(primary?: string | null, fallbacks?: string | null): string {
  const urls = [...parseUrlTokens(primary), ...parseUrlTokens(fallbacks)];
  const seen = new Set<string>();
  const lines: string[] = [];
  for (const u of urls) {
    if (!seen.has(u)) {
      seen.add(u);
      lines.push(u);
    }
  }
  return lines.join('\n');
}

/** Primeira URL = principal; resto = fallbacks (CSV para o backend). */
export function splitUrlListInput(text: string): { primary: string; fallbacks: string } {
  const all = parseUrlTokens(text);
  if (all.length === 0) {
    return { primary: '', fallbacks: '' };
  }
  return {
    primary: all[0],
    fallbacks: all.slice(1).join(',')
  };
}
